interface MetaInfoProps {
  refNo: string;
  date: string;
  name?: string;
  address?: string;
}

const MetaInfo2 = ({ refNo, date, name, address }: MetaInfoProps) => (
  <div className="mb-4 px-8 text-[15px]">
    <div className="flex flex-row justify-between text-[15px]" style={{fontFamily: "Times New Roman"}}>
    <p className="text-gray-400">Ref: {refNo}</p>
    <p className="text-gray-400">Date: {date}</p>
    </div>
    {name && (
    <p className="text-[15px]"><b>Name:</b> {name}</p>
    )}
    {address && (
    <p className="text-[15px]"><b>Address:</b> {address}</p>
    )}
  </div>
);

export default MetaInfo2;
